import React from "react";
import "./style.scss";
import { MdArrowBackIosNew } from "react-icons/md";
import { useTranslation } from "react-i18next";
import EAButton from "../shared/Buttons/EAButton";

interface IProps {
  backFunction: () => void;
  title: string;
}

const MobileEAPageHeader: React.FC<IProps> = ({ backFunction, title }) => {
  const { t } = useTranslation();
  return (
    <div className="modal-window-header flex-start-center">
      <EAButton
        title={t("wroc")}
        onClick={() => {
          backFunction();
        }}
        startIcon={<MdArrowBackIosNew />}
        variant="outlined"
      />
      <h1>{title}</h1>
    </div>
  );
};

export default MobileEAPageHeader;
